export const TABLE_ORDERS_HEAD = [0, 1, 2, 3, 4];
export const TABLE_ORDERS_BODY = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
export const TABLE_ORDERS_CELL = [0, 1, 2, 3, 4, 5];

export const DEFAULT_PARAMS = { end: 10, order: 'DESC', sort: 'id', start: 0 };

export const TABLE_CLIENTS_HEAD = [0, 1, 2, 3];
export const TABLE_CLIENTS_BODY = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
export const TABLE_CLIENTS_CELL = [0, 1, 2, 3, 4];
